export enum AppRoutes {
    MAIN = "main",
    LOGIN = "login",
    PLAYER = "player",
    CALCULATOR = "calc",
    RAG = "rag",
    TermsAndConditions = "terms-and-conditions",
    // last
    NOT_FOUND = "not_found",
}

export const getRouteMain = (lang = "en") => `/${lang}`;
export const getRouteLogin = (lang = "en") => `/${lang}/login`;
export const getRoutePlayer = (lang = "en") => `/${lang}/player`;
export const getRouteCalculator = (lang = "en") => `/${lang}/calc`;
export const getRouteRag = (lang = "en") => `/${lang}/rag`;
export const getRouteTermsAndConditions = (lang = "en") =>
    `/${lang}/terms-and-conditions`;


const locales = ["ru", "en", "cn", "ar", "es", "de"];

export const AppRouteByPathPattern: Record<
    string,
    { route: AppRoutes; lang: string }
> = {
    [getRouteMain("en")]: { route: AppRoutes.MAIN, lang: "en" },
    [getRouteLogin("en")]: { route: AppRoutes.LOGIN, lang: "en" },
    [getRoutePlayer("en")]: { route: AppRoutes.PLAYER, lang: "en" },
    [getRouteCalculator("en")]: { route: AppRoutes.CALCULATOR, lang: "en" },
    [getRouteRag("en")]: { route: AppRoutes.RAG, lang: "en" },
    ...Object.fromEntries(
        locales.flatMap((lang) => [
            [`/${lang}`, { route: AppRoutes.MAIN, lang }],
            [`/${lang}/login`, { route: AppRoutes.LOGIN, lang }],
            [`/${lang}/player`, { route: AppRoutes.PLAYER, lang }],
            [`/${lang}/calc`, { route: AppRoutes.CALCULATOR, lang }],
        ]),
    ),
};
